import * as React from 'react';

const SectionLeftFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="section-left-fill_svg__eds-icon--section-left-fill_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="section-left-fill_svg__eds-icon--section-left-fill_base"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#010101"
            d="M4 20h8v-4H4v4z"
        />
        <path
            id="section-left-fill_svg__eds-icon--section-left-fill_middle"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#010101"
            d="M4 10v4h16v-4H4z"
        />
        <path
            id="section-left-fill_svg__eds-icon--section-left-fill_top"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#010101"
            d="M4 4v4h16V4H4z"
        />
    </svg>
);

SectionLeftFillSvg.displayName = 'SectionLeftFillSvg';
export default SectionLeftFillSvg;
